/**
 * strip-markdown-for-preview
 *
 * Strips markdown syntax from text for use in collapsed/summary previews
 * so * # ** etc. are not shown as raw characters.
 */

/**
 * Returns plain text suitable for a one-line or short preview (e.g. collapsed state).
 * Removes headers (#), bold/italic (* _), code (`), links [text](url) -> text.
 */
export function stripMarkdownForPreview(text: string): string {
  if (!text || typeof text !== 'string') return ''
  return text
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/_(.+?)_/g, '$1')
    .replace(/^#+\s*/gm, '')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/```[\s\S]*?```/g, '')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/\s+/g, ' ')
    .trim()
}
